import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isWebPSupported } from 'shared/lib/utils';
import { Image } from 'shared/lib/SureDesignSystem';
import LazyLoad from 'react-lazyload';

import styles from './Review.module.css';

const propTypes = {
  review: PropTypes.shape({
    id: PropTypes.number,
    content: PropTypes.string,
    author: PropTypes.string,
    position: PropTypes.string,
    logo: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

class Review extends PureComponent {
  render() {
    const { className, review } = this.props;

    return (
      <div
        className={classnames(
          styles.wrapper,
          className,
          isWebPSupported
            ? styles.wrapperBackgroundWebp
            : styles.wrapperBackground
        )}
      >
        <div className={styles.container}>
          <div className={styles.reviewWrapper}>
            <div className={styles.review}>
              <div className={styles.reviewInner}>
                <p className={styles.reviewContent}>"{review.content}"</p>
              </div>
            </div>
          </div>
          <div className={styles.reviewAuthorWrapper}>
            <p className={styles.reviewAuthor}>{review.author}</p>
            <p className={styles.reviewAuthorPosition}>{review.position}</p>
            <LazyLoad height={40} once>
              <Image className={styles.reviewLogo} src={review.logo} />
            </LazyLoad>
          </div>
        </div>
      </div>
    );
  }
}

Review.propTypes = propTypes;
Review.defaultProps = defaultProps;

export default Review;
